import { render, staticRenderFns } from "./CouponInformation.vue?vue&type=template&id=ed51de04&scoped=true&"
import script from "./CouponInformation.vue?vue&type=script&lang=js&"
export * from "./CouponInformation.vue?vue&type=script&lang=js&"
import style0 from "./CouponInformation.vue?vue&type=style&index=0&id=ed51de04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed51de04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed51de04')) {
      api.createRecord('ed51de04', component.options)
    } else {
      api.reload('ed51de04', component.options)
    }
    module.hot.accept("./CouponInformation.vue?vue&type=template&id=ed51de04&scoped=true&", function () {
      api.rerender('ed51de04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecoupon/campaign/components/CouponInformation.vue"
export default component.exports